<template>
    <np-panel :title="panelTitle">
        <div v-if="select">
            <div class="row" v-for="doc in documentData" >
                <div class="col-12 col-md-6" >
                    <np-select2 v-model="doc.fileType" slot="label">
                        <option v-for="param in documentParam" :value="param.id">{{param.text}}</option>
                    </np-select2>
                </div>
                <div class="col-12 col-md-6">
                    <np-input :no-wrapper="true" slot="input"
                              @files="onFileSelect($event, doc)"
                              type="file">
                    </np-input>
                    <small v-if="doc.file" class="filename-label">{{doc.file.name}}</small>
                </div>
                <div class="col-12">
                </div>
            </div>
        </div>
        <div v-else >
            <np-input v-for="(doc, index) in documentData"
                      :key="`doc-${index}`"
                      :ref="`doc-${index}`"
                      :label="doc.label"
                      @files="onFileSelect($event, doc)"
                      type="file">
            </np-input>
        </div>
        <p v-if="error">
            <small style="color:red" >{{error}}</small>
        </p>
        <p v-if="successMessage">
            <small style="color:green" >{{successMessage}}</small>
        </p>
        <div v-if="select">
            <a class="btn btn-success add-document" @click="addDocument">
                <i class="fa fa-plus"></i>
            </a>
        </div>
        <a class="btn btn-default pull-right" @click="doUpload" :disabled="uploading">
            {{lang('upload')}}
            <i v-if="uploading" class="fa fa-spinner fa-spin"></i>
        </a>
    </np-panel>

</template>

<script>
    import NPInput from './np-input.vue';
    import NpPreloader from "./np-preloader.vue";
    import NpSelect2 from "./np-select2.vue";
    import NpResponsive from "./np-responsive.vue";
    import NpPanel from "./np-panel.vue";
    import local from '../mixins/locale';
    export default {
        name: "np-document-upload-widget",
        mixins: [local],
        props: {
            panelTitle: String,
            description: String,
            documents: Array,// [{fileType:'', label:'',  };
            beforeUpload: Function,
            select: Boolean, //select mode
            documentParam: Array,
            url: String
        },
        data: function(){
            return {
                fileGroups: {}, // fileGroups is the tree version of documentData
                error: null,
                successMessage: '',
                uploading: false,
                documentData: [], // [{fileType:'', file: ''}]
                files:[],
            }
        },
        created: function() {
            this.documentData = this.documents ? this.documents : [];
        },
        methods: {
            addDocument() {
                this.documentData.push({fileType:'', file: null})
            },
            reset() {
                this.documentData = this.documents;
                this.fileGroups = {};
            },
            doUpload: function() {
                let formData = new FormData();
                for(let fileType in this.fileGroups) {
                    const files = this.fileGroups[fileType];
                    for (var i = 0; i < files.length; i++) {
                        const file = files[i];
                        const name = `${fileType}[${i}]`;
                        formData.append(name, file, file.filename);
                    }
                }
                var token_key = $body.data('token-name'), token = $body.data('token-hash');
                const config = {
                    headers: {'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': `${token_key} ${token}`},
                }
                if (this.beforeUpload) {
                    formData = this.beforeUpload(formData);
                    //console.log(formData)
                }
                this.error = null;
                this.successMessage = null;
                this.uploading = true;
                this.getAxiosInstance().post(this.url, formData)
                    .then(response => {
                        const data = response.data;
                        if (data.error) {
                            this.error = `${data.error.cause}: ${data.error.explanation}`;
                        } else if (data.result === 'SUCCESS'){
                            //console.log('local:' + this.lang('document_uploaded'))
                            this.successMessage = this.lang('document_uploaded');
                        }
                        this.$emit('uploaded', this.fileGroups);
                        this.uploading = false;
                        this.reset();
                    })
                    .catch(error => {
                        this.uploading = false;
                    })
                // axios.post(this.url, formData, config)
                //     .then((response) => {
                //         //console.log(response)
                //         const data = response.data;
                //         if (data.error) {
                //             this.error = `${data.error.cause}: ${data.error.explanation}`;
                //         } else if (data.result === 'SUCCESS'){
                //             //console.log('local:' + this.lang('document_uploaded'))
                //             this.successMessage = this.lang('document_uploaded');
                //         }
                //         this.$emit('uploaded', this.fileGroups);
                //         this.uploading = false;
                //         this.reset();
                //     })
                //     .catch(() => {
                //         this.uploading = false;
                //     })
            },
            onFileSelect: function(fileList, document) {
                const file = fileList.item(0);
                document.file = file;
                if(!this.fileGroups[document.fileType]) {
                    this.fileGroups[document.fileType] = [];
                }
                this.fileGroups[document.fileType].push(file);
                ////console.log(this.documentData);
                ////console.log(this.fileGroups)
            },
        },
        components: {
            NpResponsive,
            NpSelect2,
            NpPreloader,
            'np-input': NPInput,
            'np-panel': NpPanel,

        }
    }
</script>

<style scoped>
    .panel-body {
        padding-top:0;
    }
    .add-document {
        margin-top:5px;
    }
    .filename-label {
        position: relative;
        top: -13px;
        margin-left:2px;
    }

</style>
